<template>
  <div class="container">
    <div class="formtitle">注册</div>
    <div class="formbox">
      <van-form validate-first @submit="onSubmit">
        <van-field
          v-model="form.phoneNum"
          placeholder="请输入手机号"
          :rules="formRules.phoneNum"
          class="myform"
        />
        <van-field
          v-model="form.companyName"
          placeholder="请输入纳税人名称"
          :rules="formRules.companyName"
          class="myform"
        />
        <van-field
          v-model="form.taxNum"
          placeholder="请输入纳税人识别号"
          :rules="formRules.taxNum"
          class="myform"
        />
        <van-field
          v-model="form.vcode"
          placeholder="验证码"
          :rules="formRules.vcode"
          class="myform"
        />
        <div class="formbtn">
          <van-button native-type="submit">提交</van-button>
        </div>
      </van-form>
      <span class="vcode" v-if="!isShowCountdown" @click="getCode">获取验证码</span>
      <span class="vcode" v-else>{{countDown}}s</span>
    </div>
    <p class="formtips">注册即同意注册<span>《注册协议》</span>协议</p>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form:{
        phoneNum:"",
        companyName:"",
        taxNum:"",
        vcode:"",
      },
      isShowCountdown:false,
      countDown:60,
      formRules:{
        phoneNum:[
          { required: true, message: '请输入手机号' },
          { validator: this.phoneNumError, message: '手机号格式不正确' }
        ],
        companyName:[{ validator: this.companyNameValidator, message: '请输入纳税人名称' }],
        taxNum:[
          { validator: this.taxNumValidator, message: '请输入纳税人识别号' },
          { validator: this.taxNumError, message: '纳税人识别号格式不正确' }
        ],
        vcode:[
          { required: true, message: '请输入验证码' },
        ],
      },
      timmer:null,
    }
  },
  methods:{
    getCode(){
      if(!this.form.phoneNum.trim()){
        this.$toast('请输入手机号码');
        return
      }
      var regPhoneNum = /^1[3-9]\d{9}$/
      if(!regPhoneNum.test(this.form.phoneNum)){
        this.$toast('手机号格式有误');
        return
      }
      let that = this
      that.isShowCountdown = true
      this.axios.get("/sendMsg",{params:{sjh:this.form.phoneNum}}).then(res=>{
        if(res.code==200){
          let that = this
          that.isShowCountdown = true
          this.timmer = setInterval(function(){
            that.countDown-=1
            if(that.countDown == 0){
              clearInterval(that.timmer)
              that.countDown = 60
              that.isShowCountdown = false
            }
          },1000)
        }else{
          this.$toast(res.data.msg);
        }
      })
    },
    onSubmit() {
      console.log(this.form)
      let dataJson = {
        userName:this.form.phoneNum,
        phonenumber:this.form.phoneNum,
        qymc:this.form.companyName,
        qysh:this.form.taxNum,
        code:this.form.vcode,
        openid:sessionStorage.getItem("openid")
      }
      this.axios.post("/system/user/wxZc",dataJson)
      .then(res=>{
        if(res.code==200){
          sessionStorage.setItem("token",res.token);
          sessionStorage.setItem("qymc",res.qymc)
          sessionStorage.setItem("qysh",res.qysh)
          if(sessionStorage.getItem("dz")=='bindcompany'&&res.qymc){
            this.$router.push(`/unbinding`)
          }else if(sessionStorage.getItem("dz")=='bindcompany'&&!res.qymc){
            this.$router.push(`/bindcompany`)
          }else{
            this.$router.push(`/${sessionStorage.getItem("dz")}`)
          }
        }else{
          this.$toast(res.msg)
        }
      })
    },
    companyNameValidator(val){
      if(this.form.taxNum&&!val){
        return false
      }
    },
    taxNumValidator(val){
      if(this.form.companyName&&!val){
        return false
      }
    },
    taxNumError(val){
      if(val&&(val.trim().length<15 || /[\u4E00-\u9FFF]+/.test(val))){
        return false
      }
    },
    phoneNumError(val){
      if(!/^1[3-9]\d{9}$/.test(val)){
        return false
      }
    },
  }
}
</script>

<style src="@/assets/css/css.css" scoped></style>
<style scoped>
.van-cell{
  padding: 0.48rem 0 0.32rem;
  border-bottom: 1px solid #ededed;
  line-height:1;
  font-size: 0.3rem;
}
.myform>>>.van-field__error-message{
  position: absolute;
}
.van-button--normal{
  font-size: 0.3rem;
  font-weight: bold;
  width: 100%;
  height: 0.83rem;
  background-color: #0175f3;
  color: #fff;
  border-radius: 0.45rem;
}
</style>